module.exports = __webpack_public_path__ + "static/img/IMG_0867.4d9906e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0867.jpg
// module id = CPuQ
// module chunks = 11